"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundOverlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@chakra-ui/react");
var BackgroundOverlay = function (props) {
    return ((0, jsx_runtime_1.jsx)(react_1.Box, __assign({ bottom: "0px", left: "0px", position: "absolute", right: "0px", top: "0px" }, props)));
};
exports.BackgroundOverlay = BackgroundOverlay;
